"use client";

import clsx from "clsx";
import { motion } from "framer-motion";
import React, { useState } from "react";
import { GoPlus } from "react-icons/go";
import ComponentTransition from "./ComponentTransition";

export default function FaqAccordian({ faqs }) {
    const [openStates, setOpenStates] = useState(Array(faqs.length).fill(false));

    const handleClick = (index) => {
        setOpenStates((prevOpenStates) => {
            const newOpenStates = [...prevOpenStates];
            newOpenStates[index] = !newOpenStates[index];
            return newOpenStates;
        });
    };

    return (
        <ComponentTransition className="flex flex-col items-center justify-center w-full max-w-4xl px-4 mt-10">
            {faqs.map((item, index) => (
                <motion.div
                    key={index}
                    className="w-full bg-white dark:bg-neutral-800 p-6 rounded-2xl shadow-md mb-4 transition-all duration-300"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                >
                    <button
                        onClick={() => handleClick(index)}
                        className="w-full flex justify-between items-center"
                        aria-expanded={openStates[index]}
                    >
                        <div className="flex items-center">
                            <GoPlus
                                size={24}
                                className={clsx(
                                    "mr-4 transition-transform duration-300",
                                    openStates[index] ? "rotate-45 text-black" : "rotate-0 text-black"
                                )}
                            />
                            <h2 className="text-lg md:text-xl font-semibold text-left text-black dark:text-black">
                                {item.question}
                            </h2>
                        </div>
                    </button>
                    <motion.div
                        className="overflow-hidden mt-2"
                        initial={{ height: 0 }}
                        animate={{ height: openStates[index] ? "auto" : 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                    >
                        <p className="text-black dark:text-black mt-3 px-2">
                            {item.answer}
                        </p>
                    </motion.div>
                </motion.div>
            ))}
        </ComponentTransition>
    );
}
